import { Zap, LineChart, ShieldCheck, Globe } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const INDICATORS = [
    { n: "01", label: "Fast Execution", icon: Zap, id: "brand-indicator-fast-execution" },
    { n: "02", label: "Deep Market Access", icon: LineChart, id: "brand-indicator-deep-market-access" },
    { n: "03", label: "Secure Infrastructure", icon: ShieldCheck, id: "brand-indicator-secure-infrastructure" },
    { n: "04", label: "Global Access", icon: Globe, id: "brand-indicator-global-access" },
];

export default function BrandStatement() {
    return (
        <section id="velocity" data-testid="brand-statement-section" className="relative bg-void py-24 lg:py-32">
            <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
                <Reveal>
                    <Eyebrow>The Tavonx Standard</Eyebrow>
                </Reveal>
                <Reveal delay={0.08}>
                    <h2 className="max-w-4xl font-grotesk text-4xl font-bold uppercase leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl">
                        Built for velocity.
                        <br />
                        <span className="text-grad-blue">Powered by liquidity.</span>
                    </h2>
                </Reveal>

                <Reveal delay={0.15}>
                    <div className="mt-16 grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-white/[0.07] bg-white/[0.06] lg:grid-cols-4">
                        {INDICATORS.map((it) => (
                            <div
                                key={it.n}
                                data-testid={it.id}
                                className="group relative bg-base p-7 transition-colors duration-500 hover:bg-panel lg:p-9"
                            >
                                <div className="flex items-start justify-between">
                                    <span className="font-mono text-xs tracking-[0.3em] text-cyber">
                                        {it.n}
                                    </span>
                                    <it.icon
                                        className="h-5 w-5 text-slate-600 transition-all duration-500 group-hover:text-cyber group-hover:drop-shadow-[0_0_8px_rgba(0,209,255,0.6)]"
                                        strokeWidth={1.5}
                                    />
                                </div>
                                <div className="mt-14 font-grotesk text-sm font-semibold uppercase tracking-[0.2em] text-slate-200 lg:mt-20">
                                    {it.label}
                                </div>
                                <span className="absolute inset-x-0 bottom-0 h-0.5 origin-left scale-x-0 bg-gradient-to-r from-electric to-cyber transition-transform duration-500 group-hover:scale-x-100" />
                            </div>
                        ))}
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
